import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { SSR, BASE_URL, DEFAULT_META } from './config';
import { useLocation } from 'react-router';

function SEO ({ title, description, img, keywords }) {
  const location = useLocation();
  const fullUrl = `${BASE_URL}${location.pathname}${location.search}`;

  const defaultTitle = 'InClassica International Music Festival 2021';
  const defaultDescription =
    "InClassica Dubai International Music Festival 2021 features musicians who dedicate themselves to their craft with devotion and passion. Audiences who can bathe in the sun and breathe music, carrying them to the abode of spiritual pleasure far from everyday life. The place where the astonishing young talents meet world's most famous musicians.\n" +
    'New remarkable careers which will be given a marvelous start. All this in dedication to music and arts.';

  return (
    <Helmet
      encodeSpecialCharacters={!SSR}
      defaultTitle={defaultTitle}
      titleTemplate='%s'

      // callback that tracks DOM changes
      // onChangeClientState={(newState, addedTags, removedTags) => console.log(newState, addedTags, removedTags)}
    >
      {/* html attributes */}
      <html lang='en' />

      {/* Fonts */}
      <link
        href='https://fonts.googleapis.com/css2?family=Montserrat:wght@300;500;700;900&display=swap'
        rel='stylesheet'
      />

      {/* body attributes */}
      {/* <body className="root"/> */}
      <meta
        name='google-site-verification'
        content='llBarO_C8wfD01m6Q8Q6sMldg9IfLKaFNN-36wKg5tI'
      />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      {title && <title itemProp='name'>{title || defaultTitle}</title>}
      <link rel='canonical' href={BASE_URL} />
      <meta name='og:site_name' content={DEFAULT_META.siteName} />
      <meta property='og:url' content={fullUrl} />
      <meta property='og:type' content='website' />

      <meta name='og:title' content={title || defaultTitle} />
      <meta property='og:title' content={title || defaultTitle} />
      <meta name='og:description' content={description || defaultDescription} />
      <meta name='description' content={description || defaultDescription} />

      <meta name='og:image' content={img || DEFAULT_META.img} />
      <meta property='og:image:type' content='image/jpeg' />
      <meta property='og:image:width' content='400' />
      <meta property='og:image:height' content='300' />

      <meta name='twitter:card' content='summary' />
      <meta name='twitter:url' content={fullUrl} />
      <meta name='twitter:title' content={title || defaultTitle} />
      <meta
        name='twitter:description'
        content={description || defaultDescription}
      />
      <meta name='twitter:image' content={img || DEFAULT_META.img} />
      <meta name='twitter:image:alt' content={title || defaultTitle} />
      <meta name="facebook-domain-verification" content="c3d9nzqnddjtgws3zk5k6af253c5gh" />
      <link rel='canonical' href='https://inclassica.com/'/>

      {keywords && <meta name='keywords' content={keywords} />}

      {/* -----------------------------------------------------------------Favicon----------------------------------------------------------------- */}
      {DEFAULT_META.favicon && DEFAULT_META.favicon.icon && (
        <link
          rel='shortcut icon'
          sizes='16x16 24x24 32x32 48x48 64x64'
          href={`/media/favicon/${DEFAULT_META.favicon.icon}`}
        />
      )}

      {/* --------------------------------Web-------------------------------- */}
      {DEFAULT_META.favicon &&
        DEFAULT_META.favicon.web &&
        Object.keys(DEFAULT_META.favicon.web).map(
          (keyName, i) =>
            DEFAULT_META.favicon.web[keyName] && (
              <link
                key={i}
                rel='icon'
                type='image/png'
                sizes={keyName}
                href={`/media/favicon/${DEFAULT_META.favicon.web[keyName]}`}
              />
            )
        )}
      {/* --------------------------------Web-------------------------------- */}

      {/* --------------------------------IOS-------------------------------- */}
      {DEFAULT_META.favicon &&
        DEFAULT_META.favicon.ios &&
        Object.keys(DEFAULT_META.favicon.ios).map(
          (keyName, i) =>
            DEFAULT_META.favicon.ios[keyName] && (
              <link
                key={i}
                rel='apple-touch-icon'
                href={`/media/favicon/${DEFAULT_META.favicon.ios[keyName]}`}
                sizes={keyName}
              />
            )
        )}
      <meta name='theme-color' content='#ffffff' />
      <meta content='yes' name='apple-mobile-web-app-capable' />
      <meta
        name='apple-mobile-web-app-status-bar-style'
        content='black-translucent'
      />
      {/* --------------------------------IOS-------------------------------- */}

      {/* --------------------------------Android-------------------------------- */}
      {DEFAULT_META.favicon &&
        DEFAULT_META.favicon.android &&
        Object.keys(DEFAULT_META.favicon.android).map(
          (keyName, i) =>
            DEFAULT_META.favicon.android[keyName] && (
              <link
                key={i}
                rel='icon'
                type='image/png'
                href={`/media/favicon/${DEFAULT_META.favicon.android[keyName]}`}
                sizes={keyName}
              />
            )
        )}
      {/* --------------------------------Android-------------------------------- */}

      {/* -----------------------------------------------------------------Favicon----------------------------------------------------------------- */}

      {/* --------------------------------IOS-------------------------------- */}
      {DEFAULT_META.app &&
        DEFAULT_META.app.ios &&
        Object.keys(DEFAULT_META.app.ios).map(
          (keyName, i) =>
            DEFAULT_META.app.android[keyName] && (
              <meta
                key={i}
                property={`al:ios:${keyName}`}
                content={DEFAULT_META.app.ios[keyName]}
              />
            )
        )}
      {/* --------------------------------IOS-------------------------------- */}

      {/* --------------------------------Android-------------------------------- */}
      {DEFAULT_META.app &&
        DEFAULT_META.app.android &&
        Object.keys(DEFAULT_META.app.android).map(
          (keyName, i) =>
            DEFAULT_META.app.android[keyName] && (
              <meta
                key={i}
                property={`al:android:${keyName}`}
                content={DEFAULT_META.app.android[keyName]}
              />
            )
        )}
      <meta property='al:web:url' content={fullUrl} />
      {/* --------------------------------Android-------------------------------- */}

      {/* --------------------------------Twitter-------------------------------- */}
      {DEFAULT_META.social &&
        DEFAULT_META.social.twitter &&
        Object.keys(DEFAULT_META.social.twitter).map(
          (keyName, i) =>
            DEFAULT_META.social.twitter[keyName] && (
              <meta
                key={i}
                property={`twitter:${keyName}`}
                content={DEFAULT_META.social.twitter[keyName]}
              />
            )
        )}
      <meta name='twitter:url' content={fullUrl} />
      <meta name='twitter:title' content={title || defaultTitle} />
      <meta
        name='twitter:description'
        content={description || defaultDescription}
      />
      <meta name='twitter:image' content={img || DEFAULT_META.img} />
      {/* --------------------------------Twitter-------------------------------- */}
    </Helmet>
  );
}

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  img: PropTypes.string,
  keywords: PropTypes.string,
};

export default SEO;
